import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MediaQuery from 'react-responsive';
import FabButton from '../FabButton';
import { browser } from '../BrowserSupport/';
import ManualEntryIcon from '@mui/icons-material/Keyboard';
import QRGunIcon from '../Icons/QRGun';
import CloseIcon from '@mui/icons-material/Close';
import CameraIcon from '@mui/icons-material/PhotoCamera';
import classNames from 'classnames';
import styles from './styles';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';



class AuthChooserButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            drawerOpen: false
        };
    }

    handleClick = () => {
        const isOpen = this.state.open;
        const newState = !isOpen;

        this.setState({
            open: newState
        });
    };

    handleDrawerOpen = () => {
        console.debug('drawer open')
        this.setState({ drawerOpen: true });
    };

    handleDrawerClose = () => {
        console.debug('draw close')
        this.setState({ drawerOpen: false });
    };

    handleClose = (_, reason) => {
        if (reason !== 'mouseLeave')
            this.setState({ open: false, lastClickTime: null });
    };

    handleOpen = () => {
        this.setState({ open: true });
    };

    delegateAction = (delegate, currentContext) => {
        this.handleClose();
        delegate(currentContext);
    };

    speedDialSelector = () => {

        const {
            classes,
            qrCodeClicked,
            qrScannerClicked,
            forgottenCardClicked,
            currentContext,
            text,
            disabled,
            icon: Icon
        } = this.props;

        const { open } = this.state;
        const isDisabled = Boolean(disabled);
        const eventName = text.replaceAll(' ', '');
        return (
            <ClickAwayListener onClickAway={this.handleClose}>
                <SpeedDial
                    ariaLabel={text}
                    disabled={isDisabled}
                    className={classes.speedDial}
                    icon={<SpeedDialIcon icon={<Icon />} openIcon={<CloseIcon />} />}
                    onClick={this.handleClick}
                    onClose={this.handleClose}
                    open={open}
                    direction="up"
                    FabProps={{
                        variant: 'extended',
                        style: {
                            minWidth: 160
                        },
                        'data-id': eventName,
                        ref: (button) => {
                            if (!button || button.querySelector('.SpeedDialFab-text')) return;
                            const span = document.createElement("span");
                            span.className = "SpeedDialFab-text";
                            span.textContent = text;
                            span.style.marginLeft = '8px';
                            button.appendChild(span);
                        }
                    }}
                >
                    <SpeedDialAction
                        icon={<ManualEntryIcon />}
                        tooltipTitle="Forgotten Card"
                        data-id="ForgottenCard"
                        parent-id={eventName}
                        tooltipOpen
                        FabProps={{
                            color: 'secondary',
                            'data-id': 'ForgottenCard',
                            'parent-id': eventName
                        }}
                        onClick={() => this.delegateAction(forgottenCardClicked, currentContext)} />

                    {!browser.mobile &&
                        <SpeedDialAction
                            icon={<QRGunIcon />}
                            tooltipTitle="QR Code (Scanner)"
                            tooltipOpen
                            FabProps={{
                                color: 'secondary',
                                'data-id': 'QRCode(Scanner)',
                                'parent-id': eventName
                            }}
                            onClick={() => this.delegateAction(qrScannerClicked, currentContext)} />
                    }

                    <SpeedDialAction
                        icon={<CameraIcon />}
                        tooltipTitle="QR Code (Camera)"
                        tooltipOpen
                        FabProps={{
                            color: 'secondary',
                            'data-id': 'QRCode(Camera)',
                            'parent-id': eventName
                        }}
                        onClick={() => this.delegateAction(qrCodeClicked, currentContext)} />
                </SpeedDial>
            </ClickAwayListener>
        );
    };

    toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        console.debug('toggleDrawer', open);
        this.setState({ open });

    };

    list = () => {
        {
            const {
                qrCodeClicked,
                qrScannerClicked,
                forgottenCardClicked,
                currentContext,
                classes
            } = this.props;

            return (
                <div tabIndex={0} role="button">
                    <List>
                        <ListItemButton onClick={() => this.delegateAction(qrCodeClicked, currentContext)}>
                            <ListItemIcon>
                                <CameraIcon className={classes.listItem} />
                            </ListItemIcon>
                            <ListItemText>
                                QR Code (Camera)
                            </ListItemText>
                        </ListItemButton>
                        {!browser.mobile &&
                            <ListItemButton onClick={() => this.delegateAction(qrScannerClicked, currentContext)}>
                                <ListItemIcon>
                                    <QRGunIcon className={classes.listItem} />
                                </ListItemIcon>
                                <ListItemText>
                                    QR Code (Scanner)
                                </ListItemText>
                            </ListItemButton>
                        }
                        <ListItemButton onClick={() => this.delegateAction(forgottenCardClicked, currentContext)}>
                            <ListItemIcon>
                                <ManualEntryIcon className={classes.listItem} />
                            </ListItemIcon>
                            <ListItemText>
                                Forgotten Card
                            </ListItemText>
                        </ListItemButton>
                        <Divider />
                        <ListItemButton onClick={this.handleDrawerClose}>
                            <ListItemIcon>
                                <CloseIcon className={classes.listItem} />
                            </ListItemIcon>
                            <ListItemText>
                                Close
                            </ListItemText>
                        </ListItemButton>
                    </List>
                </div>)
        }
    }





    drawerSelector = () => {
        const {
            text,
            icon: Icon,
            disabled,
            classes
        } = this.props;


        const { drawerOpen } = this.state;
        console.debug('drawer state', drawerOpen);
        const isDisabled = Boolean(disabled);

        return (
            <div>
                <FabButton data-id={text.replaceAll(' ', '')} onClick={this.handleDrawerOpen} disabled={isDisabled}>
                    <Icon />
                    <span style={{ marginLeft: 8 }}>
                        {text}
                    </span>
                </FabButton>
                <Drawer anchor="bottom" className={classes.drawer} open={drawerOpen} onClose={this.handleDrawerClose}>
                    {this.list(drawerOpen)}
                </Drawer>
            </div>);
    };

    render() {
        const {
            classes,
            preventPositioning
        } = this.props;

        const shouldPreventPosition = Boolean(preventPositioning);

        console.debug('shouldPreventPosition', shouldPreventPosition, classes.wrapper, this.props.className);

        return (
            <div className={classNames(shouldPreventPosition ? '' : classes.wrapper, this.props.className)}>
                <MediaQuery maxWidth={767}>
                    {(isSmall) => isSmall ? this.drawerSelector() : this.speedDialSelector()}
                </MediaQuery>
            </div >
        );
    }
}

AuthChooserButton.propTypes = {
    disabled: PropTypes.bool,
    text: PropTypes.string,
    forgottenCardClicked: PropTypes.func.isRequired,
    qrCodeClicked: PropTypes.func.isRequired,
    qrScannerClicked: PropTypes.func.isRequired,
    currentContext: PropTypes.string,
    icon: PropTypes.func,
    preventPositioning: PropTypes.bool
};

export default withStyles(AuthChooserButton, styles);